<style type="less" scoped>
    @import url('./css.less');
</style>
<template>
    <div class="container">
        <BusinessEchartBmap v-on:map-load="mapLoad" v-bind="$props" ref='map'>
        </BusinessEchartBmap>
    </div>
</template>

<script>
    import BusinessEchartBmap from './../../map/common/businessEchartBmap/index';
    import ChengDuCountyPolygon from './../../map/common/inMapOverlay/ChengDuCounty-Polygon/index';
    import mapPropsMinxin from './default-props-value';
    import inMap from './../../../lib/inmap';
    import heatData from './data.json';
    import mapStyle from './custom_map_config.js';

    export default {
        name: '',
        props: {

        },
        mixins: [mapPropsMinxin],
        components: {
            BusinessEchartBmap
        },
        data() {
            return {

            }
        },
        watch: {
            cityName() {

            },
            cityData() {
                console.log('data', this.data)
            }
        },
        computed: {

        },
        methods: {
            _initMap() {

                const mapComponent = this.$refs.map.getMapComponent();
                //关闭zoom
                mapComponent.setZoomConfig({
                    show: false,
                });
                // //关闭拖拽
                const polygonOverlay = new ChengDuCountyPolygon({
                    style: {
                        normal: {
                            backgroundColor: "rgba(0,133,235,0)",
                            borderColor: "rgba(6,205,255,1)",
                            borderWidth: 1
                        },
                        mouseOver: {
                            opacity: 0,
                            // backgroundColor: "rgba(0,133,235,0.6)",
                        },
                        selected: {
                            // backgroundColor: "rgba(25,158,255,1)",
                            // borderColor: "rgba(25,158,255,1)",
                        },
                    }
                });
                mapComponent.addInMapOverlay(polygonOverlay);
                polygonOverlay.setValue([]);

                // const bMap = mapComponent.getMap();
                const heatOverlay = new inMap.HeatOverlay({
                    gradient: {
                        // 0.25: 'rgb(0,0,255)',
                        0.55: 'rgb(0,255,0)',
                        0.85: 'yellow',
                        1.0: 'rgb(255,0,0)'
                    },

                    style: {
                        radius: 17, // 半径
                        maxValue: 40,

                    },
                    animation: {
                        type: 'time',
                        stepsRange: {
                            start: 0,
                            end: 100
                        },
                        trails: 10,
                        duration: 1,
                    },
                    data: heatData
                });
                mapComponent.addInMapOverlay(heatOverlay);
                // heatOverlay.setData(data);
            },
            mapLoad() {
                this._initMap();
            },
            resize() {
                this.$refs.map.resize();
            }
        },
        mounted() {

        }
    }
</script>